import { render, staticRenderFns } from "./registerStep3.vue?vue&type=template&id=1e6a50f2&"
import script from "./registerStep3.vue?vue&type=script&lang=js&"
export * from "./registerStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registerStep3.vue"
export default component.exports